"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHeadline(resultCode) {
    switch (resultCode) {
        case 'YXXX':
        case 'YXYY':
        case 'YXYN':
        case 'YXNY':
        case 'YXNN':
        case 'YYXX':
        case 'YYYY':
        case 'YYYN':
        case 'YYNY':
        case 'YYNN':
            return 'goalAchievedHeader';
        case 'NXXX':
        case 'NXYY':
        case 'NXNY':
        case 'NXNN':
        case 'NNXX':
        case 'NNYY':
        case 'NNNY':
        case 'NNNN':
        case 'NYXX':
        case 'NYYY':
        case 'NYNY':
        case 'NYNN':
        case 'YNXX':
        case 'YNYY':
        case 'YNNY':
        case 'YNNN':
            return 'goalMissedHeader';
        case 'NNYN':
        case 'NYYN':
        case 'YNYN':
        case 'NXYN':
            return 'bonusAchievedHeader';
        default:
            return '';
    }
}
exports.getHeadline = getHeadline;
function getSubHeadline(resultCode) {
    switch (resultCode) {
        case 'YYXX':
        case 'YYYY':
        case 'YYYN':
        case 'YYNY':
        case 'YYNN':
        case 'YXXX':
        case 'YXYY':
        case 'YXYN':
        case 'YXNY':
        case 'YXNN':
        case 'YNYN':
        case 'NYYN':
        case 'NNYN':
        case 'NXYN':
            return 'goalAchievedSubhead';
        case 'NNXX':
        case 'NNYY':
        case 'NYXX':
        case 'NYYY':
        case 'NXXX':
        case 'NXYY':
            return 'goalMissedSubhead';
        case 'YNXX':
        case 'YNYY':
        case 'YNNY':
        case 'YNNN':
            return 'mqMissedSubhead';
        case 'NYNY':
        case 'NNNY':
        case 'NXNY':
        case 'NXNN':
        case 'NNNN':
        case 'NYNN':
            return 'goalBonusMissedSubhead';
        default:
            return '';
    }
}
exports.getSubHeadline = getSubHeadline;
function getMessage(resultCode) {
    switch (resultCode) {
        case 'YXXX':
            return 'defaultGoalAchievedMessage';
        case 'YYXX':
            return 'defaultGoalMQAchievedMessage';
        case 'YXYY':
        case 'YXYN':
        case 'YXNY':
        case 'YXNN':
            return 'goalAchievedMessage';
        case 'NNYN':
        case 'NYYN':
        case 'NXYN':
        case 'YNYN':
            return 'notCoupledBonusAchievedMessage';
        case 'NXYY':
        case 'NYYY':
        case 'NNYY':
        case 'YNYY':
            return 'goalCoupledWithBonusMessage';
        case 'YYYY':
        case 'YYYN':
        case 'YYNY':
        case 'YYNN':
            return 'goalMQAchievedMessage';
        case 'YNNY':
        case 'YNNN':
            return 'bonusMissedMessage';
        default:
            return '';
    }
}
exports.getMessage = getMessage;
function getAdditionalMessage(resultCode) {
    switch (resultCode) {
        case 'YXYY':
        case 'YXYN':
        case 'YYYY':
        case 'YYYN':
            return 'bonusAchievedMessage';
        case 'YXNY':
        case 'YXNN':
        case 'YYNY':
        case 'YYNN':
            return 'bonusMissedMessage';
        case 'NNYN':
        case 'NXYN':
            return 'notCoupledGoalMQMissedMessage';
        case 'NYYN':
            return 'goalMissedMessage';
        case 'YNYN':
            return 'goalMqMissedMessage';
        default:
            return '';
    }
}
exports.getAdditionalMessage = getAdditionalMessage;
//# sourceMappingURL=goalquest-codes.js.map